"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.directoryPicker.selectDirectory': 'Seleccionar directorio',
    'googleDrive.directoryPicker.selected': 'Seleccionado',
};
